import React from 'react'
import PropTypes from 'prop-types'
import * as Component from './MenuItem.styles'

const MenuItem = (props) => {
  const { icon, label, ...other } = props

  return (
    <Component.Root>
      <Component.Label>{label}</Component.Label>
      <Component.MenuIcon className={ icon } { ...other } />
    </Component.Root>
  )
}

MenuItem.propTypes = {
  /** Icon class name */
  icon: PropTypes.string.isRequired,
  /** Label */
  label: PropTypes.string.isRequired,
}

export default MenuItem
